import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { useMediaQuery } from './utils/useMediaQuery';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from './Components/Footer/Footer';
import MobileNav from './Components/Nav/MobileNav';
import { Nav } from './Components/Nav/Nav';
import Pages from './Pages';
// import { themePayloadToggle } from './Redux/GlobalState/ThemeToggle';
import { setMobile } from './Redux/GlobalState/isMobile';
import { setTablet } from './Redux/GlobalState/isTablet';
import type { RootState } from './Redux/Store';
import './App.css';
import GoogeAnalytics from './GoogeAnalytics';

function App() {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isTablet = useMediaQuery('(max-width: 900px)');
  const dark = useSelector((state: RootState) => state.themeSlice.dark);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setMobile(isMobile));
  }, [isMobile, dispatch]);

  useEffect(() => {
    dispatch(setTablet(isTablet));
  }, [isTablet, dispatch]);

  useEffect(() => {
    const body = document.querySelector('body');
    if (body) {
      body.style.backgroundColor = dark ? '#090B0D' : '#FFFFFF';
      body.className = dark ? 'theme--dark' : 'theme--light';
    }
  }, [dark]);

  const showMobileNav = isTablet || isMobile;

  return (
    <BrowserRouter>
      <GoogeAnalytics />
      {showMobileNav ? <MobileNav /> : <Nav />}
      <Pages />
      <Footer />
      <ToastContainer position="top-right" autoClose={5000} />
    </BrowserRouter>
  );
}

export default App;
